import { memo } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { TextAreaField } from "@/components/ui/form/fields/text-area-field";

import { useVoucherI18nDescription } from "./hooks";

export const QuestionDescription = memo(() => {
	const { description, onSetDescription } = useVoucherI18nDescription();

	return (
		<QuestionForMain
			required={true}
			title="宿泊券の紹介文"
			guide="宿泊券の内容を伝える紹介文を書きましょう。（300文字以内推奨）"
			inputChildren={
				<TextAreaField
					errorMessage={description?.error}
					value={description?.value ?? undefined}
					handleChange={onSetDescription}
				/>
			}
		/>
	);
});

QuestionDescription.displayName = "QuestionDescription";
